export default "__VITE_ASSET__z4RpUE3L__";